import { render, staticRenderFns } from "./Configurador.vue?vue&type=template&id=2d1c0036"
import script from "./Configurador.vue?vue&type=script&lang=js"
export * from "./Configurador.vue?vue&type=script&lang=js"
import style0 from "./Configurador.vue?vue&type=style&index=0&id=2d1c0036&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports